import React, { useState, useRef, useEffect } from 'react';
import { message, MessageSubscriberRegistry, MessagePublisher } from '@iqproduct/editor-cross-domain-messaging';

const iframeStyle = {
  width: '100%',
  height: '100vh'
};

var ActionHandlers;
(function (ActionHandlers) {
  ActionHandlers["SELECT_HIGHLIGHT_ELEMENT"] = "SELECT_HIGHLIGHT_ELEMENT";
  ActionHandlers["SET_ELEMENT_BACKGROUND_COLOR"] = "SET_ELEMENT_BACKGROUND_COLOR";
  ActionHandlers["PAGE_LOAD_STATUS"] = "PAGE_LOAD_STATUS";
  ActionHandlers["SET_ADD_SECTION_MODAL"] = "SET_ADD_SECTION_MODAL";
  ActionHandlers["SET_ADD_SECTION_MODAL_POSITION"] = "SET_ADD_SECTION_MODAL_POSITION";
})(ActionHandlers || (ActionHandlers = {}));

const getPublisherData = actionHandler => {
  if (actionHandler.action === ActionHandlers.SELECT_HIGHLIGHT_ELEMENT) {
    return new message.SelectHighlightElementMessage(actionHandler.data);
  } else if (actionHandler.action === ActionHandlers.SET_ELEMENT_BACKGROUND_COLOR) {
    return new message.SetElementBackgroundColorMessage(actionHandler.data);
  } else {
    return "";
  }
};

function EditorIframe(props) {
  const [finalUrl, setFinalUrl] = useState('');
  const [visible, setVisible] = useState(false);
  const [isIframeLoad, setIsIframeLoad] = useState(false);
  const iFrameRef = useRef(null);
  const messageSubscriber = useRef(MessageSubscriberRegistry.getInstance(window));
  const publisher = useRef(null);
  const setIframeRef = () => {
    const fObj = document.getElementById('editor-iframe');
    if (!publisher.current && fObj && fObj.contentWindow) {
      publisher.current = new MessagePublisher(fObj.contentWindow);
    }
    return fObj && fObj.contentWindow;
  };
  const pageLoadSubscriber = () => {
    const subscriberType = message.Action.PAGE_LOAD_STATUS;
    messageSubscriber.current.addSubscriber(subscriberType, message => {
      props.onMessage('PAGE_LOAD_STATUS', message.data);
      setIsIframeLoad(true);
      pageLoadContent();
      return true;
    });
  };
  const pageLoadContent = () => {
    const subscriberType = message.Action.PAGE_LOAD_CONTENT;
    messageSubscriber.current.addSubscriber(subscriberType, message => {
      props.onMessage('PAGE_LOAD_CONTENT', message.data);
      return true;
    });
  };
  const clickedOnContent = () => {
    const subscriberType = message.Action.CLICKED_ON_CONTENT;
    messageSubscriber.current.addSubscriber(subscriberType, message => {
      props.onMessage('CLICKED_ON_CONTENT', message.data);
      return true;
    });
  };
  const onChangePageContentSubscriber = () => {
    const subscriberType = message.Action.GET_CHANGE_PAGE_CONTENT;
    messageSubscriber.current.addSubscriber(subscriberType, message => {
      props.onMessage('GET_CHANGE_PAGE_CONTENT', message.data);
      return true;
    });
  };
  const noHighLightElementSubscriber = () => {
    const subscriberType = message.Action.FIND_ELEMENT_STATUS;
    messageSubscriber.current.addSubscriber(subscriberType, message => {
      props.onMessage('FIND_ELEMENT_STATUS', message.data);
      return true;
    });
  };
  const setBrowserContentSubscriber = () => {
    const subscriberType = message.Action.BROWSER_CONTENT_STATUS;
    messageSubscriber.current.addSubscriber(subscriberType, message => {
      props.onMessage('BROWSER_CONTENT_STATUS', message.data);
      return true;
    });
  };
  const setBrowserContent = () => {
    const messageData = new message.SetBrowserContentMessage(props.browserContent);
    setIframeRef();
    if (messageData && publisher.current) {
      publisher.current.sendMessage(messageData);
    }
  };
  const removeNewSectionEventSubscriber = () => {
    const subscriberType = message.Action.REMOVE_NEW_SECTION_EVENT;
    messageSubscriber.current.addSubscriber(subscriberType, message => {
      props.onMessage('REMOVE_NEW_SECTION_EVENT', message.data);
      return true;
    });
  };
  const createNewSectionEventSubscriber = () => {
    const subscriberType = message.Action.CREATE_NEW_SECTION_EVENT;
    messageSubscriber.current.addSubscriber(subscriberType, message => {
      props.onMessage('CREATE_NEW_SECTION_EVENT', message.data);
      return true;
    });
  };
  const allSubscriber = () => {
    if (!messageSubscriber.current) {
      messageSubscriber.current = MessageSubscriberRegistry.getInstance(window);
    }
    pageLoadSubscriber();
    onChangePageContentSubscriber();
    noHighLightElementSubscriber();
    setBrowserContentSubscriber();
    clickedOnContent();
    removeNewSectionEventSubscriber();
    createNewSectionEventSubscriber();
  };
  useEffect(() => {
    allSubscriber();
    setIsIframeLoad(false);
  }, []);
  useEffect(() => {
    if (isIframeLoad && props.browserContent) {
      setBrowserContent();
    }
  }, [isIframeLoad]);
  useEffect(() => {
    if (props.src && props.dataSource) {
      const proxyUrl = props.dataSource.replace(/\/$/, '');
      let sourceUri = `${proxyUrl}?url=${props.src}&tenant=${props.tenant}`;
      if (props.sid) {
        sourceUri = `${sourceUri}&sid=${props.sid}`;
      }
      setFinalUrl(sourceUri);
      setVisible(true);
    }
  }, [props.dataSource, props.src, props.sid]);
  const publishAddSectionMessage = isOpen => {
    const messageData = new message.SetAddSectionModalMessage(isOpen);
    if (publisher.current) {
      publisher.current.sendMessage(messageData);
    }
  };
  const publishAddSectionPositionMessage = isOnCenter => {
    const messageData = new message.SetAddSectionModalPositionMessage(isOnCenter);
    if (publisher.current) {
      publisher.current.sendMessage(messageData);
    }
  };
  useEffect(() => {
    const messageData = getPublisherData(props.actionHandler);
    setIframeRef();
    if (messageData && publisher.current) {
      publisher.current.sendMessage(messageData);
    }
    if (props.actionHandler.action === ActionHandlers.SET_ADD_SECTION_MODAL) {
      publishAddSectionMessage(props.actionHandler.data);
    }
    if (props.actionHandler.action === ActionHandlers.SET_ADD_SECTION_MODAL_POSITION) {
      publishAddSectionPositionMessage(props.actionHandler.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(props.actionHandler)]);
  const onIframeLoaded = () => {
    setIframeRef();
  };
  useEffect(() => {
    if (props.browserContent) {
      setBrowserContent();
    }
  }, [props.browserContent]);
  return React.createElement("iframe", Object.assign({
    title: "iframe",
    id: "editor-iframe",
    ref: iFrameRef,
    onLoad: onIframeLoaded
  }, props, {
    src: finalUrl,
    style: {
      ...iframeStyle,
      display: visible ? 'initial' : 'none'
    },
    sandbox: "allow-scripts allow-same-origin allow-forms"
  }));
}

export { EditorIframe };
//# sourceMappingURL=react-editor-component.esm.js.map
